module.exports = __webpack_public_path__ + "static/img/create-everything-in-one-place.878c487.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/create-everything-in-one-place.png
// module id = y9Z7
// module chunks = 0